function initSeasonRentalBasketMap() {
    const pickupCoordsArray = DJANGO.pickupPoint.coordinates;
    const pickupCoordsObj = {lat: pickupCoordsArray[0], lng: pickupCoordsArray[1]};
    const map = new google.maps.Map(
        document.getElementById('so-pickup-map'),
        {
            zoom: 12,
            center: pickupCoordsObj,
            streetViewControl: false,
            scrollwheel: true,
            disableDefaultUI: true,
            zoomControl: true,
            styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
        }
    );

    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    new google.maps.Marker({
        position: pickupCoordsObj,
        map: map,
        icon: {
            url: `${baseUrl}/static/img/season_rental/markers/marker-2.png`,
            scaledSize: new google.maps.Size(32, 49),
        },
    });
}

function initSeasonRentalDatepicker(closedDays) {
    closedDays = closedDays.map(function(currentValue) {
        // https://bootstrap-datepicker.readthedocs.io/en/latest/options.html#daysofweekdisabled
        currentValue += 1;
        if (currentValue == 7) {
            currentValue = 0;
        }
        return currentValue;
    });
    var date = new Date();
    date.setDate(date.getDate() + 1);
    // TODO: This will not work with bootstrap-datepicker 1.10.0. The datepicker must be bound to an input or a div
    //  which can be hidden. Update basket.html when upgrading frontend
    $('#datepicker-season-rental').datepicker({
        format: 'DD, dd MM yyyy',
        daysOfWeekDisabled: closedDays,
        startDate: date,
        autoclose: true,
        title: DJANGO.i18n['Select pick-up date'],
        language: $(document.body).data('locale')
    });
    $('#datepicker-season-rental').on('changeDate', function (ev) {
        var tripDate = moment($('#datepicker-season-rental').datepicker('getDate')).format('MM/DD/YYYY');
        $.ajax({
            method: 'POST',
            url: $('#datepicker-season-rental').data('form-action'),
            data: {'trip_date': tripDate},
            success: function (xhr, ajaxOptions, thrownError) {
                $('.trip-date').html($('#datepicker-season-rental').datepicker('getFormattedDate'));
                $('.wrapper-trip-date-selection .trip-date-display').removeClass('invisible');
                $('#datepicker-season-rental').text(DJANGO.i18n['Change pick-up date']);
                var completeBookingBtn = $('#complete-booking-btn');
                completeBookingBtn.removeClass('greyed');
                completeBookingBtn.removeClass('c-button--disabled');
                completeBookingBtn.attr('href', completeBookingBtn.data('action-url'))
            },
            error: function (xhr, ajaxOptions, thrownError) {
                alert(xhr.responseJSON.trip_date[0]);
            }
        });
    });
}

function getSeasonRentalBootsPrice(category, boots_is_new, boots_size) {
    var result_price;
    if (['kids', 'youth'].includes(category)) {
        if (boots_size <= 35) {
            result_price = boots_is_new ? 55 : 39;
        } else if (35.5 <= boots_size && boots_size <= 40) {
            result_price = boots_is_new ? 89 : 69;
        } else if (40.5 <= boots_size && boots_size <= 43) {
            result_price = boots_is_new ? 99 : 79;
        } else if (43.5 <= boots_size && boots_size <= 50) {
            result_price = boots_is_new ? 159 : 99;
        }
    } else if (category == 'adults') {
        if (boots_size <= 35) {
            result_price = boots_is_new ? 99 : 79;
        } else if (35.5 <= boots_size && boots_size <= 50) {
            result_price = boots_is_new ? 159 : 99;
        }
    }
    return result_price
}


window.seasonRentalBasketGoogleMapsOnLoad = initSeasonRentalBasketMap;
window.initSeasonRentalDatepicker = initSeasonRentalDatepicker;
window.getSeasonRentalBootsPrice = getSeasonRentalBootsPrice;

jQuery( document ).ready(function($) {
    $('.c-cart-sum__items [class^="col"]').matchHeight();
    $('.trip-date-display, .c-cart-sum__col-date-picker').matchHeight();
});



// WEBPACK FOOTER //
// ./private/js/season_rental/basket.js